module.exports = __webpack_public_path__ + "img/comments.535e8c64.png";